module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "tabNavs",
    staticClass: "tabNavs"
  }, [_vm._l((_vm.navs), function(item, index) {
    return _c('div', {
      key: index,
      class: ['tabItem', {
        'act': _vm.navAct === index
      }],
      on: {
        "click": function($event) {
          _vm.tabChange($event, index)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item) + "\n    ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "moveLine",
    style: (_vm.lineStr)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-af520fea"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/inCComps/tabNavs.vue
// module id = 1549
// module chunks = 1